/*Shop Edition*/
jQuery(function () {
  var mobile = false;
  var tablet = false;
  var desktop = false;
  function checkWidth() {
    var viewportWidth = window.viewportSize.getWidth();
    if (viewportWidth <= 660) {
      if (!mobile) {
        $("body").removeClass("desktop tablet").addClass("mobile");
        $("body.pgProduct ul.slides li a").contents().unwrap();
        $("#pgHome div.hdr-banner").insertAfter("header");
        $("body.pgCategory div.hdr-banner").insertAfter("header");
        $("body.pgProduct div.hdr-banner").insertAfter("header");
      }
      mobile = true;
      desktop = false;
      tablet = false;
    } else if (viewportWidth >= 661 && viewportWidth <= 960) {
      if (!tablet) {
        $("body").removeClass("mobile desktop").addClass("tablet");
        $("#pgHome div.hdr-banner").insertBefore("header");
        $("body.pgCategory div.hdr-banner").insertBefore("div.category");
        $("body.pgProduct div.hdr-banner").prependTo("div.content");
      }
      mobile = false;
      desktop = false;
      tablet = true;
    } else {
      if (!desktop) {
        $("body").removeClass("mobile tablet").addClass("desktop");
        $("#pgHome div.hdr-banner").insertBefore("header");
        $("body.pgCategory div.hdr-banner").insertBefore("div.category");
        $("body.pgProduct div.hdr-banner").prependTo("div.content");
      }
      mobile = false;
      desktop = true;
      tablet = false;
    }
    if (viewportWidth <= 1070) {
      $("header .search").insertAfter("header .utilities");
    }else {
      $("header .search").insertBefore("header .utilities .shop-cart");
    }
  }
  checkWidth();

  if(mobile){
  $(window).on("orientationchange", checkWidth);
}else{
  $(window).on("resize", checkWidth);
}
  function checkHeight() {
    var viewportHeight = window.viewportSize.getHeight();
    $("#pgHome .hp-wrap, #pgHome video").css("height", viewportHeight + "px");
  }
  checkHeight();
  $(window).on("resize", checkHeight);
  $(".scroll a").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top,
      },
      1000
    );
  });
  var hpNav = $("#pgHome .hp-nav");
  if (hpNav.length) {
    var stickyNav = $(hpNav).offset().top;
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > stickyNav) {
        $("body").addClass("to-top");
      } else {
        $("body").removeClass("to-top");
      }
    });
  }
  $(" div.row-text, .hp-wrap-container h1, .hp-nav, .tagline")
    .addClass("hidden")
    .viewportChecker({
      classToAdd: "visible anim fadeInDown",
      offset: 100,
    });
  /* Menus*/
/*   function toggleSearch() {
    $('.searchbox').toggleClass('searchbox-open');
    const searchBox =  $('.searchbox');
    const tSearchString = $("#tSearchString");
    if((searchBox.hasClass('searchbox-open'))){
      searchBox.one("transitionend",() =>{
      if(tSearchString !== document.activeElement){
        tSearchString.trigger("focus");
      }
    })
  }
}
  function toggleAccount() {
    $('.header-account div .menu-wrapper').slideToggle('fast');
    $('#btn_account').toggleClass('account-active account-inactive');
  }
  function toggleSites() {
    console.log("Cuenta");
    $("#btn_global").toggleClass("sites-active sites-inactive");
    $(".global-sites div ul").slideToggle("fast",function(){
      const sitesListLinks = document.querySelectorAll('.global-sites a');
      sitesListLinks[0].focus();
    });
  }
  function toggleTopNav() {
    $("#btn-main-nav").toggleClass("activated inactive");
    $("ul.top-nav").slideToggle("fast").toggleClass("opened closed");
    $("body").toggleClass("menu-open");
  }
  $("html").on("click", function () {
    if ($("ul.top-nav").not(".desktop ul.top-nav").is(":visible")) {
      $("ul.top-nav").not(".mobile ul.top-nav").slideUp("fast");
      $("#btn-main-nav")
        .not(".mobile #btn-main-nav")
        .toggleClass("inactive activated");
      $("body").not("body.mobile").toggleClass("menu-open");
    }
  });

  $("#btn_account").on("click", function () {
    if ($("ul.top-nav").not("body.desktop ul.top-nav").is(":visible")) {
      toggleTopNav();
    }
    if ($(".global-sites div ul").is(":visible")) {
      toggleSites();
    }
    toggleAccount();
  });

  $("#btn_global").on("click", function () {
    if ($("ul.top-nav").not("body.desktop ul.top-nav").is(":visible")) {
      toggleTopNav();
    }
    if ($(".header-account div .menu-wrapper").is(":visible")) {
      toggleAccount();
    }
    if( $('.searchbox').hasClass('searchbox-open') ){ toggleSearch() }
    toggleSites();
  });

  $(".global-sites > div > p, #btn-main-nav, #btn_account").on("click", function (event) {
    event.stopPropagation();
  });

  $("#btn-main-nav").on("click", function () {
    if ($(".global-sites div ul").is(":visible")) {
      toggleSites();
    }
    if ($(".header-account div ul").is(":visible")) {
      toggleAccount();
    }
    toggleTopNav();
  }); */


  $(function () {
    var accountMenuBtn = $('#btn_account');
    var accountWrapper = $('#hdrAccountWrapper');

    function toggleSites() {
      $("#btn_global").toggleClass("sites-active sites-inactive");
      $(".global-sites .menu-wrapper").slideToggle("fast",function(){
        const sitesListLinks = document.querySelectorAll('.global-sites a');
        sitesListLinks[0].focus();
      });
    }

    function toggleSearch() {
      const searchBox =  $('.searchbox');
      searchBox.toggleClass('searchbox-open');
      const tSearchString = $("#tSearchString");
      if((searchBox.hasClass('searchbox-open'))){
        searchBox.one("transitionend",() =>{
          if(tSearchString !== document.activeElement){
            tSearchString.trigger("focus");
          }
        })
      }
  }
    function toggleAccount() {
        accountWrapper.toggleClass('active inactive');
        $('.header-account div .menu-wrapper').slideToggle('fast', function(){
          $('#btn_account').toggleClass('account-active account-inactive');
          const accountMenuFocusableEl = document.querySelectorAll('#hdrAccountWrapper [data-ada-focusable="true"]');
                accountMenuFocusableEl[0].focus();
        });
    }

    function toggleLeftNav() {
        if ($("#btn-left-nav").hasClass("leftnav-inactive")) {
            $("div.left-nav").animate({
                left: '0px'
            }, 200, 'linear');
            $("#btn-left-nav").toggleClass('leftnav-inactive leftnav-active').next().addClass('nav-opened');
        } else {
            $("div.left-nav").animate({
                left: '-350px'
            }, 200, 'linear');
            $("#btn-left-nav").toggleClass('leftnav-active leftnav-inactive ').next().removeClass('nav-opened');
        }
    }

    function toggleMainNav() {
        $('#btn-main-nav').toggleClass('inactive activated').next().slideToggle('fast');
        $("ul.top-nav").slideToggle("fast").toggleClass("opened closed");
        $("body").toggleClass("menu-open");
        HAHAccessibility.trapFocus({
          container: '.top-nav',
          closeElement: '#btn-main-nav',
          outsideContainerCloseButton: '#btn-main-nav',
          triggerHTMLElement: '#btn-main-nav'
        })
    }

    function blurCloseSites(event) {
        if ($('.global-sites #btn_global').hasClass('sites-active')) { 
            const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
            let nextFocusParentID = null;
            if (event.relatedTarget) {
                nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null
            }
            if (currentParentID !== nextFocusParentID) {
                toggleSites(); 
            }
        }
    }

    function blurCloseSearch(event) {
        if ($('.searchbox').hasClass('searchbox-open')) { 
            const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
            let nextFocusParentID = null;
            if (event.relatedTarget) {
                nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null
            }
            if (currentParentID !== nextFocusParentID) {
                toggleSearch(); 
            }
        }
    }

    function blurCloseAccount(event) {
        if (accountWrapper.hasClass('active')) { 
            const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
            let nextFocusParentID = null;
            if (event.relatedTarget) {
                nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null
            }
            if (currentParentID !== nextFocusParentID) {
                toggleAccount(); 
            }
        }
    }

    function showHideSites () {
        //if( $('.global-sites #btn_global').hasClass('sites-active') ){ toggleSites() }
        if ($('.searchbox').hasClass('searchbox-open')) { toggleSearch() }
        if ($('#btn-main-nav').hasClass('activated')) { toggleMainNav() }
        if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
        if (accountWrapper.hasClass('active')) { toggleAccount() }
        toggleSites();
        if( $('.global-sites #btn_global').hasClass('sites-active') ){ 
            const sitesListLinks = document.querySelectorAll('.global-sites a');
            sitesListLinks.forEach((el) => {
                el.addEventListener('blur', blurCloseSites);
            });
        };
    }

    function showHideSearch () {
        if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
        //if( $('.searchbox').hasClass('searchbox-open') ){ toggleSearch() }
        if ($('#btn-main-nav').hasClass('activated')) { toggleMainNav() }
        if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
        if (accountWrapper.hasClass('active')) { toggleAccount() }
        toggleSearch()
        if( $('.searchbox').hasClass('searchbox-open') ){ 
            const searchMenuFocusableEl = document.querySelectorAll('#tSearchContainer [data-ada-focusable="true"]');
            searchMenuFocusableEl.forEach((el) => {
                el.addEventListener('blur', blurCloseSearch);
            });
        }
    }

    function showHideAccount () {
        if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
        if( $('.searchbox').hasClass('searchbox-open') ){ toggleSearch() }
        if ($('#btn-main-nav').hasClass('activated')) { toggleMainNav() }
        if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
        //if (accountWrapper.hasClass('active')) { toggleAccount() }
        toggleAccount();
        if( accountWrapper.hasClass('active') ){ 
            const acoountMenuFocusableEl = document.querySelectorAll('#hdrAccountWrapper [data-ada-focusable="true"]');
            acoountMenuFocusableEl.forEach((el) => {
                el.addEventListener('blur', blurCloseAccount);
            });
        }
    }

    $('.global-sites #btn_global').on('mousedown', showHideSites);
    $('.global-sites #btn_global').on('keydown', (event) => {
        if (event.key === 'Enter') {
            showHideSites();
        }
    });

    $('.searchbox').on('mousedown', showHideSearch);
    $('.searchbox').on('keydown', (event) => {
        if (event.key === 'Enter') {
            showHideSearch();
        }
    });

    $('.searchbox .searchbox-input').on('mousedown', (e) =>{
      e.stopPropagation();
    });

    accountMenuBtn.on('mousedown', showHideAccount);
    accountMenuBtn.on('keydown', (event) => {
        if (event.key === 'Enter') {
            showHideAccount();
        }
    });

    $("#btn-left-nav").on('click', function () {
        if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
        if ($('.searchbox').hasClass('searchbox-open')) { toggleSearch() }
        if ($('#btn-main-nav').hasClass('activated')) { toggleMainNav() }
        //if( $('#btn-left-nav').hasClass('leftnav-active') ){ toggleLeftNav() }
        if (accountWrapper.hasClass('active')) { toggleAccount() }
        toggleLeftNav();
    });

    $("#btn-main-nav").on('click', function () {
        if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
        if ($('.searchbox').hasClass('searchbox-open')) { toggleSearch() }
        //if( $('#btn-main-nav').hasClass('activated') ){ toggleMainNav() }
        if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
        if (accountWrapper.hasClass('active')) { toggleAccount() }
        toggleMainNav();
    });

    $('html').on('click', function () {
        if ($(".global-sites li ul").not(".mobile .global-sites li ul").is(":visible")) {
            $('.global-sites > li > p').toggleClass('sites-inactive sites-active').next("ul").slideToggle('fast');
        }
    });

    $('.global-sites > li > p').on('click', function (event) {
        event.stopPropagation();
    });

});


  /*Fancybox*/
  $(".item-image .swiper-wrapper li a, .fancybox").fancybox({
    openEffect: "elastic",
    openSpeed: 350,
    closeEffect: "elastic",
    closeSpeed: 350,
    nextEffect: "fade",
    nextSpeed: 200,
    padding: 2,
    margin: 20,
  });
//Product Page Item description collapse and tabs
$(function () {
  const $tabLinksWrap = $('#tabs > .tab-links');
  const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);

  $("#tabs > div").hide();
  $("#tabs > div:first").show();
  $tabFirstBtn.addClass('active');
  
  $tabLinksWrap.on('click', 'button', function () {
    const $this = $(this);
    const $sibling = $this.siblings();

    $sibling.removeClass('active').attr({
      'tabindex': '-1',
      'aria-selected': 'false'
    });

    $this.addClass('active').attr({
      'tabindex': '0',
      'aria-selected': 'true'
    });

    var currentTab = $this.attr('aria-controls');
    $("#tabs > div").hide();
    $(`#${currentTab}`).show();

    return false;
  });
});
  /*Search */
/*   var submitIcon = $(".searchbox-icon");
  var inputBox = $(".searchbox-input");
  var searchBox = $(".searchbox");
  var isOpen = false;
  submitIcon.on("click", function () {
    if (isOpen == false) {
      searchBox.addClass("searchbox-open");
      inputBox.trigger("focus");
      isOpen = true;
    } else {
      searchBox.removeClass("searchbox-open");
      inputBox.trigger("focusout");
      isOpen = false;
    }
  });
  submitIcon.on("mouseup", function () {
    return false;
  });
  searchBox.on("mouseup", function () {
    return false;
  });
  $(document).on("mouseup", function () {
    if (isOpen == true) {
      $(".searchbox-icon").css("display", "block");
      submitIcon.trigger("click");
    }
  }); */

/*   $(function () {
    var accountWrapper = $('#hdrAccountWrapper');

    $('.searchbox-icon').on('click', function () {
        if ($('.global-sites #btn_global').hasClass('sites-active')) { toggleSites() }
        //if( $('.searchbox').hasClass('searchbox-open') ){ toggleSearch() }
        if ($('#btn-main-nav').hasClass('activated')) { toggleMainNav() }
        if ($('#btn-left-nav').hasClass('leftnav-active')) { toggleLeftNav() }
        if (accountWrapper.hasClass('active')) { toggleAccount() }
        toggleSearch()
    });

    $('.global-sites > li > p').on('click', function (event) {
        event.stopPropagation();
    });

}); */

  $("body").addClass("usa");

  if(document.getElementById('videoPlayerWrapper') != null){
    videoPlayerInit(jQuery.browser.mobile)
  } 

  /*END DOC READY*/
});
/*SHOULD BE OUTSIDE OF DOC READY */
/* Videos*/
(function (a) {
  (jQuery.browser = jQuery.browser || {}).mobile =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      a
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      a.substr(0, 4)
    );
})(navigator.userAgent || navigator.vendor || window.opera);
if (!jQuery.browser.mobile) {
  $("body#pgHome #hp-video").html(
    "<video autoplay loop muted><source src='video/edition-diamond-video.mp4' type='video/mp4'><source src='video/edition-diamond-video.webm' type='video/webm'><source src='video/edition-diamond-video.ogv' type='video/ogg'></video>"
  );
  $("body.pgCategory #ctg-lifestyle-video").html(
    "<video autoplay muted><source src='video/ctg-lifestyle.mp4' type='video/mp4'><source src='video/ctg-lifestyle.webm' type='video/webm'><source src='video/ctg-lifestyle.ogv' type='video/ogg'></video>"
  );
  $("body.pgCategory #ctg-artistseries-video").html(
    "<video autoplay muted loop><source src='video/ctg-artists.mp4' type='video/mp4'></video>"
  );
  $("body.pgCategory #ctg-limitededition-video").html(
    "<video autoplay muted><source src='video/ctg-limited.mp4' type='video/mp4'></video>"
  );
  $(
    "body.pgCategory #ctg-sleep-video, body.pgCategory #ctg-linens-video, body.pgCategory #ctg-fauxfurthrows-video"
  ).html(
    "<video autoplay muted><source src='video/ctg-sleep.mp4' type='video/mp4'><source src='video/ctg-sleep.webm' type='video/webm'><source src='video/ctg-sleep.ogv' type='video/ogg'></video>"
  );
  $(
    "body.pgCategory #ctg-sleep-video, body.pgCategory #ctg-linens-video, body.pgCategory #ctg-editionthrows-video"
  ).html(
    "<video autoplay muted><source src='video/ctg-sleep.mp4' type='video/mp4'><source src='video/ctg-sleep.webm' type='video/webm'><source src='video/ctg-sleep.ogv' type='video/ogg'></video>"
  );
  $("body.pgCategory #ctg-fragrance-video").html(
    "<picture><source srcset='../../images/misc/fill.gif' media='(max-width: 660px)' ><img srcset='../../images/banners/ctg-fragrance-flickering.gif' alt='Edition Candle'> </picture>"
  );
  $("canvas, #cavs-script").show();
} else {
  $("video").hide();
  $("canvas, #cavs-script").hide();
}

/*SHOULD BE OUTSIDE OF DOC READY */
function buttonUp() {
  var inputVal = $(".searchbox-input").val();
  inputVal = inputVal.trim().length;
  if (inputVal !== 0) {
    $(".searchbox-icon").css("display", "none");
    $("#searchSubmit").css("display", "block");
  } else {
    $(".searchbox-input").val("");
    $(".searchbox-icon").css("display", "block");
    $("#searchSubmit").css("display", "none");
  }
}

function videoPlayerInit(isMobile) {
  //----------PLAYBACK-------------
  
  function togglePlay() {
    updatePlayButton();
    if (video.paused || video.ended) {
      video.play();
    } else {
      video.pause();
    }
  }
  function updatePlayButton() {
    for (var index = 0; index < playbackIcons.length; index++) {
      var icon = playbackIcons[index];
      icon.classList.toggle('hidden-none');
    }
  }
  //----------TIME STUFF-------------
  function formatTime(timeInSeconds) {
    var result = new Date(timeInSeconds * 1000).toISOString().substring(19, 14);

    return {
      minutes: result.substring(2, 0),
      seconds: result.substring(6, 3),
    };
  }

  function initializeVideo() {
    var videoDuration = Math.round(video.duration);
    seek.setAttribute('max', videoDuration);
    duration.setAttribute('max', videoDuration);
    var time = formatTime(videoDuration);
    duration.innerText =  time.minutes+':'+time.seconds ;
    duration.setAttribute('datetime', time.minutes+'m '+time.seconds+'s');
    inactivityTime();
    volumeInactivity();
  }

  function updateTimeElapsed() {
    var time = formatTime(Math.round(video.currentTime));
    timeElapsed.innerText = time.minutes+':'+time.seconds;
    timeElapsed.setAttribute('datetime', time.minutes+'m '+time.seconds+'s');
  }
  function updateProgress() {
    seek.value = Math.floor(video.currentTime);

  }
  function skipAhead(event) {
      var skipTo = event.target.dataset.seek ? event.target.dataset.seek : event.target.value;
      video.currentTime = skipTo;
      seek.value = skipTo;
  }
  //--------------VOLUME----------------
  function mute(){
      video.muted=!video.muted;
      volumeMute.classList.toggle('hidden-none');
      if(video.volume>0.5){
          volumeHigh.classList.toggle('hidden-none');
      }   else{
          volumeLow.classList.toggle('hidden-none');
      }
  }
  function updateVolume() {
      video.volume = volumeBar.value;
      if (video.muted || video.volume==0) {
          mute();
      }
      if(video.volume>0){
          if(video.volume<0.5){
              volumeHigh.classList.add('hidden-none');
              volumeLow.classList.remove('hidden-none');
          }   else{
              volumeHigh.classList.remove('hidden-none');
              volumeLow.classList.add('hidden-none');
          }
      }
  }
  function volumeInactivity(){
      var volumeTimer;
      var isVolumeHovered;
      document.onmousemove = resetVolumeTimer;
      volumeControls.onmouseenter = function () {isVolumeHovered=true;};
      volumeControls.onmouseleave = function () {isVolumeHovered=false;};
      function conditionalVolumeHiding(){
          if(!isVolumeHovered){
              hideVolumeBar();
          }
      }
      function resetVolumeTimer() {
          clearTimeout(volumeTimer);
          volumeTimer = setTimeout(conditionalVolumeHiding, 500);
      }
  }
  function showVolumeBar() {
      volumeBar.classList.add('--transition-opacity');

  }
  function hideVolumeBar() {
      volumeBar.classList.remove('--transition-opacity');
  }
  //--------------VOLUME----------------
  function fullscreen() {
    if(video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen()
    } else if(video.mozRequestFullScreen) {
      video.mozRequestFullScreen()
    }
  }

  //--------------MOBILE/DESKTOP----------------
  function controlsVisibilityOn(){
    if(alreadyPlayed){
      videoControls.classList.add('--transition-opacity');
      areControlsHidden = false;
      setTimeout(function(){
          transitioning = false;
      }, 500);
    }
  }
  function controlsVisibilityOff(){
      if (alreadyPlayed && !video.paused){
          if(!transitioning){
              transitioning = true;
              areControlsHidden = true;
              videoControls.classList.remove('--transition-opacity');
              hideVolumeBar();
              setTimeout(function(){
                  transitioning = false;
              }, 500);
          }  
      }
  }
  function mobilePlay(){
      hasAlreadyPlayed();
      if (areControlsHidden){
          controlsVisibilityOn();
      }else{
          if(video.paused){
              togglePlay();
              controlsVisibilityOff();
          } else{
              togglePlay();  
          }
      }
  }
  function hasAlreadyPlayed() {
      if(!alreadyPlayed){
          alreadyPlayed = true;
      }
      
  }
  function inactivityTime() {
      var time;
      window.onload = resetTimer;
      video.onmousemove = resetTimer;
      function resetTimer() {
          if(hasAlreadyPlayed && !video.paused){
              clearTimeout(time);
              time = setTimeout(controlsVisibilityOff, 2000);
          }
      }
    }
    function firstHomePlay(){
      if(videoCover){
        document.querySelector('#videoCover h3').style.display ='none'
        document.querySelector('#videoCover .video-icon').style.display ='none'
        videoControls.style.display= 'block';
        videoCover.style.opacity = 0;
      }
    }
    function videoCoverKeyDown(e) {
      // SPACE key to play/pause
      if(e.keyCode === 32) {
        e.preventDefault()
        firstHomePlay()
        togglePlay()
      }
      // M key to mute/unmute
      if(e.keyCode === 77) {
        e.preventDefault()
        mute()
      }
      // LEFT ARROW key to rewind video
      if(e.keyCode === 37) {
        e.preventDefault()
        video.currentTime -= 1
      }
      // RIGHT ARROW key to advance video
      if(e.keyCode === 39) {
        e.preventDefault()
        video.currentTime += 1
      }
      // F key to go fullscreen
      if(e.keyCode === 70) {
        e.preventDefault()
        fullscreen()
      }
    }


  //--------------GENERAL----------------
  var videoPlayerWrapper = document.getElementById('videoPlayerWrapper');
  var video = document.getElementById('mainVideo');
  var videoControls = document.getElementById('videoControls');
  var playButton = document.getElementById('play');
  var videoWorks = !!document.createElement('video').canPlayType;
  var playbackIcons = document.querySelectorAll('.playback-icon');
  var videoCover = document.getElementById('videoCover');

  //--------------TIMEBAR----------------
  var timeElapsed = document.getElementById('timeElapsed');
  var duration = document.getElementById('duration');
  var seek = document.getElementById('seek');

  //--------------VOLUME----------------
  var volumeControls = document.getElementById('volumeControls');
  var volumeButton = document.getElementById('volumeButton');
  var volumeMute = document.getElementById('volumeMute');
  var volumeLow = document.getElementById('volumeLow');
  var volumeHigh = document.getElementById('volumeHigh');
  var volumeBar = document.getElementById('volumeBar');

  //--------------FULLSCREEN----------------
  var fullscreenControls = document.getElementById('fullscreenControls');

  //----------MOBILE BEHAVIOR-------------
  var alreadyPlayed = false;
  var transitioning = false;
  var areControlsHidden = false;
  var controlsHovering = false;

  if (videoWorks) {
    video.controls = false;
    videoControls.classList.remove('hidden-none');
  } 
  //----------LISTENERS-------------
  
  video.addEventListener('ended', updatePlayButton);
  video.addEventListener('loadeddata', initializeVideo);
  video.addEventListener('timeupdate', updateTimeElapsed);
  video.addEventListener('timeupdate', updateProgress);
  seek.addEventListener('input', skipAhead);
  volumeBar.addEventListener('input', updateVolume);
  volumeButton.addEventListener('click',mute);
  video.addEventListener('play', hasAlreadyPlayed);
  fullscreenControls.addEventListener('click', fullscreen);
  
  //----------MOBILE ADJUSTING-------------

  if (isMobile) {
      video.addEventListener('pause', controlsVisibilityOn);
      video.addEventListener('touchend',mobilePlay);
      playButton.addEventListener('touchend', mobilePlay);
  } else {
      playButton.addEventListener('click', togglePlay);
      video.addEventListener('click',togglePlay);
      video.addEventListener('pause', controlsVisibilityOn);
      videoPlayerWrapper.addEventListener('click', firstHomePlay);
      videoPlayerWrapper.addEventListener('keydown', videoCoverKeyDown);
      videoPlayerWrapper.addEventListener('mousemove', controlsVisibilityOn);
      videoPlayerWrapper.addEventListener('focus', controlsVisibilityOn);
      videoPlayerWrapper.addEventListener('mouseleave', controlsVisibilityOff);
      videoControls.addEventListener('mouseenter', function () {controlsHovering=true;});
      videoControls.addEventListener('mouseleave', function () {controlsHovering=false;});
      volumeButton.addEventListener('mouseover',showVolumeBar);
      if(videoCover){
        videoControls.classList.toggle('--transition-opacity')
      }
  }
}
/*END SHOULD BE OUTSIDE OF DOC READY */

/*Slide In Animations Viewport Check*/
(function ($) {
  $.fn.viewportChecker = function (useroptions) {
    var options = {
      classToAdd: "visible",
      offset: 100,
      callbackFunction: function (elem) {},
    };
    $.extend(options, useroptions);
    var $elem = this,
      windowHeight = $(window).height();

    this.checkElements = function () {
      // Set some vars to check with
      var viewportTop = Math.max(
          $("html").scrollTop(),
          $("body").scrollTop(),
          $(window).scrollTop()
        ),
        viewportBottom = viewportTop + windowHeight;

      $elem.each(function () {
        var $obj = $(this);
        if ($obj.hasClass(options.classToAdd)) {
          return;
        }
        var elemTop = Math.round($obj.offset().top) + options.offset,
          elemBottom = elemTop + $obj.height();
        if (elemTop < viewportBottom && elemBottom > viewportTop) {
          $obj.addClass(options.classToAdd);
          options.callbackFunction($obj);
        }
      });
    };
    $(window).on("scroll", this.checkElements);
    this.checkElements();
    $(window).on("resize", function (e) {
      windowHeight = e.currentTarget.innerHeight;
    });
  };
})(jQuery);
